import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const FormOverrideModal = ({ isShown, onOverrideConfirm, onClose }) => {
  const [comments, setComments] = useState('');

  const onConfirm = () => {
    onOverrideConfirm({
      isDraft: false,
      override: true,
      valid: false,
      reason: '4',
      comments
    });
  };

  return (<ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    title="Invalidate All Forms"
    btnConfirmTitle="Confirm"
    btnConfirmClass="btn-danger"
    btnCancelTitle="Cancel"
    onConfirm={ onConfirm }
    onCancel={ onClose }
    modalSize=""
  >
    <p>The form will be invalidated for all accounts</p>
    <div className="form-group">
      <select
        id="form=override-dd"
        className="form-select"
        disabled
        value="4"
      >
        <option value="">Select a reason</option>
        <option value="1">Supporting document attached.</option>
        <option value="2">Exception approval attached.</option>
        <option value="3">System issue.</option>
        <option value="4">Client specific treatment, specified below.</option>
        <option value="5">Other reason, specified below.</option>
      </select>
    </div>
    <div className="form-group">
      <textarea
        id="form-override-ta"
        className="form-input"
        rows="3"
        value={ comments }
        onChange={ e => setComments(e.target.value != null ? e.target.value : '') }
      />
    </div>
  </ModalWrapper>);
};

FormOverrideModal.propTypes = {
  isShown: PropTypes.bool.isRequired,
  onOverrideConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default FormOverrideModal;
